import * as React from 'react';

const SquareSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="square_svg__eds-icon--square_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="square_svg__eds-icon--square_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 21h18V3H3v18zm-1 1h20V2H2v20z"
        />
    </svg>
);

SquareSvg.displayName = 'SquareSvg';
export default SquareSvg;
